import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { BodySmall, LabelLarge } from '@styled';
import { GlobalModalContext } from '@context/globalModalContext';

const Slide = styled.div`
    display: flex;
    align-items: center;
    background-color: #fff;
    text-align: left;
`;

const SlideLink = styled.a`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

const ProfileStrengtheningSlide = ({ header, description, link, icon, modalComponent, hash }) => {
    const Icon = icon;
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const onClick = () => {
        if (link) {
            window.location = link;
            return;
        }
        setModalChildren(modalComponent);
        setIsModalOpen(true);
        if (hash) {
            window.location.hash = hash;
        }
    };

    return (
        <Slide>
            <SlideLink onClick={onClick}>
                <div className="mr-3">
                    <img src={Icon} alt="" style={{ width: 64 }} />
                </div>

                <div>
                    <LabelLarge>{header}</LabelLarge>
                    <BodySmall>{description}</BodySmall>
                </div>
            </SlideLink>
        </Slide>
    );
};
ProfileStrengtheningSlide.propTypes = {
    header: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
    icon: PropTypes.string,
    hash: PropTypes.string,
    modalComponent: PropTypes.element,
};

export default ProfileStrengtheningSlide;
